import React from 'react';
import Header from "../../widgets/header/Header";
import Footer from "../../widgets/footer/Footer";
import styles from "./MainLayout.module.css";
export default function MainLayout({children, className}) {
    return (
        <main className={className}>
            <Header/>
            <div className={styles.content}>
                {children}
            </div>
            <Footer/>
        </main>
    )
}